import { createRoot } from 'react-dom/client'
import { Gallery } from './Gallery'
import './styles.css'

createRoot(document.getElementById('root')).render(<Gallery />)
